export default "__VITE_ASSET__3ff5fbaf__"